// ------------------------------------------------------------------
// 新TOPページ：メインビジュアル（スライダー）
// docs/TOPページデザイン/new_amazing/js/main.js の initHeroSlider を移植。
// スライド情報はセクション内の <script type="application/json" data-ntop-hero-slides> から読む。
// ------------------------------------------------------------------
if (!customElements.get('ntop-hero')) {
  class NtopHero extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-ntop-hero-slides]');
      try {
        this.slides = dataEl ? JSON.parse(dataEl.textContent) : [];
      } catch (_err) {
        this.slides = [];
      }
      if (!this.slides.length) return;

      this.current = 0;
      this.autoplayId = null;
      this.interval = (parseFloat(this.dataset.interval) || 6) * 1000;
      this.spQuery = window.matchMedia('(max-width: 768px)');

      this.viewport = this.querySelector('[data-hero-viewport]');
      this.mainCard = this.querySelector('[data-hero-main]');
      this.mainImg = this.querySelector('[data-hero-main-img]');
      this.prevSide = this.querySelector('[data-hero-side="prev"]');
      this.nextSide = this.querySelector('[data-hero-side="next"]');
      this.prevSideImg = this.prevSide?.querySelector('img');
      this.nextSideImg = this.nextSide?.querySelector('img');
      this.dotsWrap = this.querySelector('[data-hero-dots]');

      this.buildDots();
      this.bindArrows();
      this.bindSwipe();

      this.onMediaChange = () => this.render();
      this.spQuery.addEventListener?.('change', this.onMediaChange);

      this.onBlockSelect = (e) => {
        const index = Number(e.target?.dataset?.slideIndex);
        if (Number.isNaN(index)) return;
        this.stopAutoplay();
        this.goTo(index);
      };
      this.onBlockDeselect = () => this.startAutoplay();
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      this.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      this.render();
      if (this.slides.length > 1) {
        this.startAutoplay();
        this.restartDotProgress();
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
      this.spQuery?.removeEventListener?.('change', this.onMediaChange);
    }

    srcFor(slide) {
      return this.spQuery.matches && slide.sp ? slide.sp : slide.pc;
    }

    buildDots() {
      if (!this.dotsWrap || this.slides.length < 2) return;
      this.dotsWrap.innerHTML = '';
      this.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ntop-hero__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `${i + 1}枚目のスライドを表示`);
        const fill = document.createElement('span');
        fill.className = 'ntop-hero__dot-fill';
        dot.appendChild(fill);
        dot.addEventListener('click', () => {
          this.startAutoplay();
          this.goTo(i);
        });
        this.dotsWrap.appendChild(dot);
      });
    }

    render() {
      const total = this.slides.length;
      const slide = this.slides[this.current];
      const prev = this.slides[(this.current - 1 + total) % total];
      const next = this.slides[(this.current + 1) % total];

      if (this.mainImg) {
        this.mainImg.src = this.srcFor(slide);
        this.mainImg.alt = slide.alt || '';
      }
      if (this.mainCard) {
        if (slide.link) this.mainCard.setAttribute('href', slide.link);
        else this.mainCard.removeAttribute('href');
      }
      // 左右のスライドもメインと同じ画像（スマホでは SP 用画像）を使う
      if (this.prevSideImg) this.prevSideImg.src = this.srcFor(prev);
      if (this.nextSideImg) this.nextSideImg.src = this.srcFor(next);

      if (this.dotsWrap) {
        Array.from(this.dotsWrap.children).forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.current);
        });
      }
    }

    animateSlide(direction) {
      if (!this.mainCard || typeof this.mainCard.animate !== 'function') return;

      const mainOffset = direction === 'next' ? 28 : -28;
      const sideOffset = direction === 'next' ? 16 : -16;
      const options = { duration: 280, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' };

      this.mainCard.animate(
        [
          { transform: `translateX(${mainOffset}px)`, opacity: 0.72 },
          { transform: 'translateX(0)', opacity: 1 }
        ],
        options
      );
      [this.prevSide, this.nextSide].forEach((side) => {
        if (!side || typeof side.animate !== 'function') return;
        side.animate(
          [
            { transform: `translateX(${sideOffset}px)`, opacity: 0.72 },
            { transform: 'translateX(0)', opacity: 1 }
          ],
          options
        );
      });
    }

    goTo(index) {
      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      const direction =
        nextIndex === this.current ? null : (nextIndex - this.current + total) % total < total / 2 ? 'next' : 'prev';

      this.current = nextIndex;
      this.render();
      if (direction) this.animateSlide(direction);
      this.restartDotProgress();
    }

    stopAutoplay() {
      if (this.autoplayId === null) return;
      window.clearInterval(this.autoplayId);
      this.autoplayId = null;
    }

    startAutoplay() {
      this.stopAutoplay();
      if (this.slides.length < 2 || this.isHovering) return;
      this.autoplayId = window.setInterval(() => this.goTo(this.current + 1), this.interval);
    }

    restartDotProgress() {
      if (!this.dotsWrap) return;
      Array.from(this.dotsWrap.children).forEach((dot) => {
        const fill = dot.querySelector('.ntop-hero__dot-fill');
        if (!fill) return;
        fill.getAnimations?.().forEach((animation) => animation.cancel());
        fill.style.transform = 'scaleX(0)';
      });

      const fill = this.dotsWrap.children[this.current]?.querySelector('.ntop-hero__dot-fill');
      if (!fill || typeof fill.animate !== 'function' || this.autoplayId === null) return;
      fill.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
        duration: this.interval,
        easing: 'linear',
        fill: 'forwards'
      });
    }

    bindArrows() {
      const prevBtn = this.querySelector('[data-hero-prev]');
      const nextBtn = this.querySelector('[data-hero-next]');
      prevBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.startAutoplay();
        this.goTo(this.current - 1);
      });
      nextBtn?.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.startAutoplay();
        this.goTo(this.current + 1);
      });
    }

    // スワイプ（タッチ / マウスドラッグ）
    bindSwipe() {
      const viewport = this.viewport;
      if (!viewport || this.slides.length < 2) return;

      const SWIPE_THRESHOLD = 40; // px
      const isArrow = (target) => target.closest('[data-hero-prev], [data-hero-next]');
      let dragStartX = null;
      let dragging = false;
      let didSwipe = false;
      let activePointerId = null;
      let activeTouchId = null;

      // 新しい操作を始めるたびにリセットする（タッチのスワイプでは click が発生せず、
      // 立ったままのフラグが次のタップの遷移を止めてしまうため）
      const beginDrag = (x) => {
        dragStartX = x;
        dragging = true;
        didSwipe = false;
      };
      const swipe = (delta) => {
        if (delta <= -SWIPE_THRESHOLD) {
          didSwipe = true;
          this.startAutoplay();
          this.goTo(this.current + 1); // 左へスワイプ → 次へ
        } else if (delta >= SWIPE_THRESHOLD) {
          didSwipe = true;
          this.startAutoplay();
          this.goTo(this.current - 1); // 右へスワイプ → 前へ
        }
      };
      const endDrag = () => {
        dragging = false;
        dragStartX = null;
        activePointerId = null;
        activeTouchId = null;
        viewport.classList.remove('is-dragging');
      };

      // マウスのドラッグ。setPointerCapture を使うと click の発生先がスライダー全体に
      // 付け替わり、画像のリンクが押せなくなるため、指を離したことは window で受け取る
      viewport.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (isArrow(e.target)) return;
        activePointerId = e.pointerId;
        beginDrag(e.clientX);
        viewport.classList.add('is-dragging');
      });
      window.addEventListener('pointerup', (e) => {
        if (!dragging || e.pointerId !== activePointerId) return;
        swipe(e.clientX - dragStartX);
        endDrag();
      });
      window.addEventListener('pointercancel', (e) => {
        if (e.pointerId !== activePointerId) return;
        endDrag();
      });
      viewport.addEventListener('mousedown', (e) => {
        if (e.button !== 0 || isArrow(e.target)) return;
        e.preventDefault();
      });

      viewport.addEventListener(
        'touchstart',
        (e) => {
          if (isArrow(e.target)) return;
          const touch = e.changedTouches[0];
          if (!touch) return;
          activeTouchId = touch.identifier;
          beginDrag(touch.clientX);
        },
        { passive: true }
      );
      viewport.addEventListener('touchend', (e) => {
        if (!dragging || activeTouchId === null) return;
        const touch = Array.from(e.changedTouches).find((item) => item.identifier === activeTouchId);
        if (!touch) return;
        swipe(touch.clientX - dragStartX);
        endDrag();
      });
      viewport.addEventListener('touchcancel', () => endDrag());

      // スワイプ直後のクリックでリンク遷移しないようにする
      viewport.addEventListener(
        'click',
        (e) => {
          if (didSwipe) {
            e.preventDefault();
            e.stopPropagation();
            didSwipe = false;
          }
        },
        true
      );

      // 左右にのぞいているスライドを押したら、そのスライドへ移動する
      this.prevSide?.addEventListener('click', () => {
        this.startAutoplay();
        this.goTo(this.current - 1);
      });
      this.nextSide?.addEventListener('click', () => {
        this.startAutoplay();
        this.goTo(this.current + 1);
      });

      // PC：マウスを乗せている間は自動切り替えを止め、押す直前にスライド（リンク先）が変わらないようにする
      // （タップでも mouseenter が発生するスマホでは止めない）
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
      viewport.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        this.isHovering = true;
        this.stopAutoplay();
        this.restartDotProgress();
      });
      viewport.addEventListener('mouseleave', () => {
        if (!this.isHovering) return;
        this.isHovering = false;
        this.startAutoplay();
        this.restartDotProgress();
      });
      viewport.addEventListener('dragstart', (e) => e.preventDefault());
    }
  }

  customElements.define('ntop-hero', NtopHero);
}
